import ReactDOMServer from "react-dom/server";
import { MilieuPopupContainer } from "./popupTableHelper";
import React from "react";
import { NearestEnvironmentApi, PopupApi, WaterCoursEnvironmentApi } from "../../api";
import { showDigitsIndicValue } from "../../helper";

export const getInfoMilieuSensibility = async (feature) => {
  let attributes,
    popupInfo,
    waterCours,
    nearest,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;

  try {
    popupInfo = await PopupApi.getPopupApi(attributes.Code);
    waterCours = await WaterCoursEnvironmentApi.getWaterCours(attributes.Code);
    if (waterCours.data.coastline) {
      await WaterCoursEnvironmentApi.updateWaterCours(
        {
          ...waterCours.data,
          label: 'littoral',
        },
        attributes.Code,
      );
    }
    if (popupInfo.data.name === null && !waterCours.data.coastline) {
      Promise.allSettled([
        await NearestEnvironmentApi.getNearest(attributes.Code),
      ]).then(async (results) => {
        const [result1] = results;
        if (result1.status === 'fulfilled') {
          nearest = result1.value.data;
          await WaterCoursEnvironmentApi.updateWaterCours(
            {
              ...waterCours.data,
              label: nearest.name,
              stationLabel: nearest.stations[0].name,
            },
            attributes.Code,
          );
        }
      });
    }
  } catch (error) {
    console.log('Error occurred while executing fetch calls');
  }

  const { name, usageRating, transferRating, sensitivityRating } =
    popupInfo.data;
  let milieu;
  if (await waterCours.data.coastline) {
    milieu = 'littoral';
  } else if (await name) {
    milieu = name;
  } else if (await nearest) {
    milieu = nearest.name;
  }
  const tableElements = {
    Milieu: milieu,
    'Note d’usage': usageRating,
    'Coef de transfert': showDigitsIndicValue(transferRating),
    'Note de sensibilité': showDigitsIndicValue(sensitivityRating),
  };
  content.innerHTML = ReactDOMServer.renderToString(
    <MilieuPopupContainer
      title={attributes.Description}
      tableElements={(await milieu)
          ? tableElements
          : {
              Milieu:
                "Il n'y a pas de milieu associé à l'installation dans un rayon de 25km",
            }}
    />
  );
  return content;
}

export const getInfoMilieuDilution = async (feature) => {
  let attributes,
    popupInfo,
    waterCours,
    nearest,
    content = document.createElement('div');
  attributes = feature.graphic.attributes;

  try {
    popupInfo = await PopupApi.getPopupEnvCateg(attributes.Code);
    waterCours = await WaterCoursEnvironmentApi.getWaterCours(attributes.Code);
    if (waterCours.data.coastline) {
      await WaterCoursEnvironmentApi.updateWaterCours(
        {
          ...waterCours.data,
          label: 'littoral',
        },
        attributes.Code,
      );
    }
    if (popupInfo.data[0].milieu === null && !waterCours.data.coastline) {
      Promise.allSettled([
        await NearestEnvironmentApi.getNearest(attributes.Code),
      ]).then(async (results) => {
        const [result1] = results;
        if (result1.status === 'fulfilled') {
          nearest = result1.value.data;
          await WaterCoursEnvironmentApi.updateWaterCours(
            {
              ...waterCours.data,
              label: nearest.name,
              stationLabel: nearest.stations[0].name,
            },
            attributes.Code,
          );
        }
      });
    }
  } catch (error) {
    console.log('Error occurred while executing fetch calls');
  }

  let milieu = 'NR';
  if (await waterCours.data.coastline) {
    milieu = 'littoral';
  } else if (popupInfo.data.length !== 0 && popupInfo.data[0].milieu !== null) {
    milieu = popupInfo.data[0].milieu;
  }
  const tableElements = {
    Milieu: milieu,
    'Nombre de déclassements': (attributes.DilutionNote !== 'Null' && attributes.DilutionNote !== undefined) ? attributes.DilutionNote : 'NR',
  };
  content.innerHTML = ReactDOMServer.renderToString(
    <MilieuPopupContainer
      title={attributes.Description}
      tableElements={(await milieu)
          ? tableElements
          : {
              Milieu:
                "Il n'y a pas de milieu associé à l'installation dans un rayon de 25km",
            }}
    />
  );
  return content;
}